import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgElectricHeater = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 140,
	height: 100,
	viewBox: "0 0 140.0 100.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 60,
			y: 0,
			width: 80,
			height: 100,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 15,
			width: 40,
			height: 70,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 70,
			y: 17.5,
			width: 60,
			height: 15,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 70,
			y: 42.5,
			width: 60,
			height: 15,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 70,
			y: 67.5,
			width: 60,
			height: 15,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 40.0 25.0 L 70.0 25.0 M 40.0 50.0 L 70.0 50.0 M 40.0 75.0 L 70.0 75.0 M 85.0 17.5 L 85.0 32.5 M 100.0 17.5 L 100.0 32.5 M 115.0 17.5 L 115.0 32.5 M 85.0 42.5 L 85.0 57.5 M 100.0 42.5 L 100.0 57.5 M 115.0 42.5 L 115.0 57.5 M 85.0 67.5 L 85.0 82.5 M 100.0 67.5 L 100.0 82.5 M 115.0 67.5 L 115.0 82.5 M 25.0 40.0 L 15.0 40.0 L 15.0 60.0 L 25.0 60.0 M 15.0 50.0 L 22.0 50.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgElectricHeater;
